/* eslint-disable no-restricted-globals */
import { useState, useRef } from "react";
import DataTable from "../Table/Datatable.js";
import { format as dateFormat } from "date-fns";
import { useEffect } from "react";
import { DOMAIN_API_HOST } from "../../../configs/main.js";
import "./dsp.scss";
import { INIT_FILTER_VALUE } from "./filters.js";
import { Box, MenuItem } from "@material-ui/core";
import { FormControl, InputLabel, Select } from "@mui/material";
import { useSnackbar } from "notistack";
import DateFromTo from "../../../widgets/DateFromTo/DateFromTo.js";
import { Switch } from "@mui/material";
import { regionsData } from "./geolist.js";
import * as z from "zod";


const defaultStyles = {
  maxHeight: "1000px",
  height: "830px",
  overflowY: "scroll",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  padding: "32px",
};


// Единый список форматов для обеих модалок
const DSP_FORMATS = ['banner', 'video', 'native', 'inapp-banner', 'inapp-video', 'inapp-native'];

const DSP_PLATFORM_NAMES = { programmatic: 'Programmatic', retargeo: 'Retargeo' };

const computePartnerLimitUtilization = (list) => {
  const result = { programmatic: null, retargeo: null };

  Object.keys(DSP_PLATFORM_NAMES).forEach((platformKey) => {
    const platformName = DSP_PLATFORM_NAMES[platformKey];
    const platformItems = list.filter((i) => i.platform_name === platformName);
    let limit = null;
    let count = 0;

    const totalItem = platformItems.find((i) => i.content_type === null);
    if (totalItem) {
      limit = Number(totalItem.views_daily_limit) || null;
      count = Number(totalItem.views_daily_count) || 0;
    } else {
      const formatItems = platformItems.filter((i) => i.content_type !== null);
      if (formatItems.length > 0) {
        limit = formatItems.reduce((acc, it) => acc + (Number(it.views_daily_limit) || 0), 0) || null;
      }
    }

    if (limit && limit > 0) {
      result[platformKey] = Math.round((count / limit) * 100);
    }
  });

  return result;
};

const getLimitUtilizationColor = (percent) => {
  if (percent >= 100) return '#ef4444';
  if (percent >= 80) return '#f97316';
  return '#22c55e';
};







const DatePickerTest = ({ defaultValue, value, onChange }) => {
  const [selectedDate, setSelectedDate] = useState(defaultValue || '');

  useEffect(() => {
    const isTimestamp = (input) => 
      typeof input === 'number' || /^\d{10,}$/.test(String(input));
  
    if (value !== undefined && value !== null) {
      setSelectedDate(isTimestamp(value) ? formatDatePicker(value) : value);
    } else if (defaultValue) {
      setSelectedDate(isTimestamp(defaultValue) ? formatDatePicker(defaultValue) : defaultValue);
    }
  }, [value, defaultValue]);
  
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    
    if (value === undefined || value === null) {
      setSelectedDate(newDate);
    }
    
    if (onChange) {
      onChange(newDate);
    }
  };

  return (
    <div style={stylesDatePicker.datepickerContainer}>
      <input 
        type="date" 
        value={selectedDate} 
        onChange={handleDateChange} 
        style={stylesDatePicker.datepickerInput}
      />
    </div>
  );
};



const formatDatePicker = (date, istext = false) => {
  if (date === 0 || !date) return;
  const d = new Date(date * 1000);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  if (istext) return `${day}.${month}.${year}`
  return `${year}-${month}-${day}`;
};

const stylesDatePicker = {
  datepickerContainer: {
    padding: "5px 0 0 0",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  datepickerInput: {
    padding: '8px',
    fontSize: '14px',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    outline: 'none',
    transition: 'border-color 0.3s ease',
    ':hover': {
      borderColor: '#888',
    },
    ':focus': {
      borderColor: '#007bff',
    },
  },
};


const addOneDay = (date) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1);
  return newDate;
};


const BannersStatsData = ({ partnerData }) => {
  const [filtersValue, setValue] = useState(INIT_FILTER_VALUE);
  const [filterArr, setFilter] = useState([]);
  const [upd, setUpd] = useState(false);
  const [tableType, setTableType] = useState("finance");
  const [reportType, setReportType] = useState("internal");
  const [reportView, setReportView] = useState("not_fake");
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );

      const _startDate = typeof filtersValue.date.date_start === "number" ? new Date(filtersValue.date.date_start) : filtersValue.date.date_start
      const _endDate = typeof filtersValue.date.date_end === "number" ? new Date(filtersValue.date.date_end) : filtersValue.date.date_end

      const date_start = new Date(`${_startDate.getFullYear()}.${_startDate.getMonth()+1}.${_startDate.getDate()} 00:00:00+03:00`).getTime() / 1000
      const date_end = addOneDay(new Date(`${_endDate.getFullYear()}.${_endDate.getMonth()+1}.${_endDate.getDate()} 00:00:00+03:00`)).getTime() / 1000

      switch (tableType) {
        case "details": {
          const detailResponse = await fetch(
            `${DOMAIN_API_HOST}/api/v1/ssp-stats/details?ssppartner_id=${partnerData.id}&target_type=REACH&date_from=${date_start}&date_to=${date_end}&page=${currentPage}&report_type=${reportType}&limit=10`,
            {
              method: "GET",
              headers: myHeaders,
            }
          );
          if (detailResponse.ok) {
            const data = await detailResponse.json();
            setFilter(data.data);
            setTotalPages(data.total_pages);
          }
          break;
        }
        case "domain": {
          const domainResponse = await fetch(
            `${DOMAIN_API_HOST}/api/v1/ssp-stats/details_by_domain?ssppartner_id=${partnerData.id}&date_from=${date_start}&date_to=${date_end}&page=${currentPage}&report_type=${reportType}&limit=10`,
            {
              method: "GET",
              headers: myHeaders,
            }
          );
          if (domainResponse.ok) {
            const data = await domainResponse.json();
            setFilter(data.data);
            setTotalPages(data.total_pages);
          }
          break;
        }
        case "finance": {
          const response = await fetch(
            `${DOMAIN_API_HOST}/api/v1/ssp-stats/details_by_finance?ssppartner_id=${partnerData.id}&date_from=${date_start}&date_to=${date_end}&page=${currentPage}&report_type=${reportType}&limit=10`,
            {
              method: "GET",
              headers: myHeaders,
            }
          );
          if (response.ok) {
            const data = await response.json();
            setFilter(data.data);
            setTotalPages(data.total_pages);
          }
          break;
        }
        case "geo": {
          const geoResponse = await fetch(
            `${DOMAIN_API_HOST}/api/v1/ssp-stats/details_by_geo?ssppartner_id=${partnerData.id}&date_from=${date_start}&date_to=${date_end}&page=${currentPage}&report_type=${reportType}&limit=10`,
            {
              method: "GET",
              headers: myHeaders,
            }
          );
          if (geoResponse.ok) {
            const data = await geoResponse.json();
            setFilter(data.data);
            setTotalPages(data.total_pages);
          }
          break;
        }
        default:
          break;
      }
      setIsLoading(false);
    }

    if (filtersValue.date.date_start && filtersValue.date.date_end) {
      setIsLoading(true);
      fetchData();
    }
    console.log(tableType)
  }, [upd, currentPage]);

  const detailColumns = [
    {
      Header: "Дата и время",
      accessor: "created_at",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "IP",
      accessor: "remote_address",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Сайт",
      accessor: "domain",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Гео",
      accessor: "geo",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "CPM ставка",
      accessor: "cost",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
  ];


  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };


  function detailGetTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateB - dateA;
    });
  
    return sortedData.map((el) => {
      return {
        created_at: <div className="td">{el.created_at ? dateFormat(new Date(el.created_at), "dd.MM.yyyy HH:mm:ss") : "-"}</div>,
        remote_address: <div className="td">{el.remote_address ? el.remote_address : "-"}</div>,
        domain: <div className="td">{el.domain ? el.domain : "Нет"}</div>,
        geo: <div className="td">{regionsData[el.geo] || el.geo || "Нет"}</div>,
        cost: <div className="td">{el.cost ? el.cost + " руб." : "-"}</div>,
      };
    });
  }

  const getGeoColumns = () => {
    let columns = [
      {
        Header: "Гео",
        accessor: "geo",
        maxWidth: 400,
        minWidth: 80,
        width: 250,
      },
      {
        Header: "Показы",
        accessor: "impressions",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
    ];
    
    if (["internal", "default"].includes(reportType)) {
      columns.push({
        Header: "Просмотры",
        accessor: "clicks",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
      {
        Header: "CTR",
        accessor: "ctr",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      });
      
    }
    
    return columns;
  }


  function geoGetTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });
  
    return sortedData.map((el) => {
      return {
        geo: <div className="td">{regionsData[el.geo] || el.geo || "Нет"}</div>,
        impressions: <div className="td">{el.impressions ? el.impressions : "0"}</div>,
        clicks: <div className="td">{el.clicks ? el.clicks : "0"}</div>,
        ctr: <div className="td">{el.ctr ? Number(el.ctr).toFixed(2) + "%" : "0%"}</div>,
      };
    });
  }
  
  const getDomainColumns = () => {
    let columns = [
      {
        Header: "Сайт",
        accessor: "domain",
        maxWidth: 400,
        minWidth: 80,
        width: 250,
      },
      {
        Header: "ID сайта",
        accessor: "site_id",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
      {
        Header: "Показы",
        accessor: "impressions",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
    ];
    
    if (["internal", "default"].includes(reportType)) {
      columns.push({
        Header: "Просмотры",
        accessor: "clicks",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
      {
        Header: "CTR",
        accessor: "ctr",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      });
    }
    
    columns.push(
      {
        Header: "eCPM",
        accessor: "ecpm",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
      {
        Header: "Затраты",
        accessor: "total_cost",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      }
    );

    return columns;
  }


  function domainGetTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });
  
    return sortedData.map((el) => {
      return {
        domain: <div className="td">{el.domain ? el.domain : "Нет"}</div>,
        site_id: <div className="td">{el.site_id ? el.site_id : "Нет"}</div>,
        impressions: <div className="td">{el.impressions ? el.impressions : "0"}</div>,
        clicks: <div className="td">{el.clicks ? el.clicks : "0"}</div>,
        ctr: <div className="td">{el.ctr ? Number(el.ctr).toFixed(2) + "%" : "0%"}</div>,
        ecpm: <div className="td">{el.average_cpm ? el.average_cpm : "0"}</div>,
        total_cost: <div className="td">{el.total_cost ? el.total_cost : "0"}</div>,
      };
    });
  }

  const getFinanceColumns = () => {
    let columns = [
      {
        Header: "Дата",
        accessor: "date",
        maxWidth: 400,
        minWidth: 80,
        width: 200,
      },
      {
        Header: "Показы",
        accessor: "impressions",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
    ];
    
    if (["internal", "default"].includes(reportType)) {
      columns.push({
        Header: "Клики",
        accessor: "clicks",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
      {
        Header: "CTR",
        accessor: "ctr",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      });
    }
    
    columns.push(
      {
        Header: "eCPM",
        accessor: "ecpm",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      },
      {
        Header: "Затраты",
        accessor: "total_cost",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      }
    );

    if (reportView === "not_fake") {
      columns.push({
        Header: "Показы с сетки",
        accessor: "external_impressions",
        maxWidth: 400,
        minWidth: 80,
        width: 170,
      });

      columns.push({
        Header: "Процент факт. показов",
        accessor: "impressions_ratio",
        maxWidth: 400,
        minWidth: 80,
        width: 150,
      });
    }

    return columns
  }


  function financeGetTableData() {
    const sortedData = filterArr.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });
  
    return sortedData.map((el) => {
      return {
        date: <div className="td">{el.date ? dateFormat(new Date(el.date), "dd.MM.yyyy") : "-"}</div>,
        impressions: <div className="td">{el.impressions ? el.impressions : "0"}</div>,
        impressions_ratio: <div className="td">{el.impressions_ratio ? Number(el.impressions_ratio * 100).toFixed(2) + "%" : "0%"}</div>,
        external_impressions: <div className="td">{el.external_impressions ? el.external_impressions : "0"}</div>,
        clicks: <div className="td">{el.clicks ? el.clicks : "0"}</div>,
        ctr: <div className="td">{el.ctr ? Number(el.ctr).toFixed(2) + "%" : "0%"}</div>,
        ecpm: <div className="td">{el.average_cpm ? el.average_cpm : "0"}</div>,
        total_cost: <div className="td">{el.total_cost ? el.total_cost : "0"}</div>,
      };
    });
  }

  const handleDateChange = (value) => {
    setValue((prev) => ({
      ...prev,
      date: { date_end: value[1] ?? "", date_start: value[0] ?? "" },
    }));
  };



  return (
    <div style={{ width: "100%", height: "95%", display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 20 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <div style={{ display: "flex", gap: 20 }}>
            <div style={{ width: "410px" }}>
              <DateFromTo
                from={new Date(new Date().setHours(0, 0, 0, 0) - 1 * 24 * 60 * 60 * 1000).getTime()}
                to={new Date(new Date().setHours(23, 59, 59, 999)).getTime()}
                handleChange={handleDateChange}
              />
            </div>
            <Box sx={{ width: 175 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Тип отчёта
                </InputLabel>
                <Select
                  style={{
                    height: 32,
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="Партнёр"
                  id="demo-select-small-label"
                  defaultValue={"finance"}
                  onChange={(e) => {
                    console.log(e.target.value);
                    setTableType(e.target.value);
                    setCurrentPage(1);
                    setUpd(!upd);
                  }}
                >
                  {/* <MenuItem value={"details"}>Детальный</MenuItem> */}
                  <MenuItem value={"geo"}>По гео</MenuItem>
                  <MenuItem value={"domain"}>По доменам</MenuItem>
                  <MenuItem value={"finance"}>По финансам</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ width: 220 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  id="demo-select-small-label"
                  sx={{ lineHeight: 1, opacity: "80%", fontSize: 14 }}
                >
                  Вид отчёта
                </InputLabel>
                <Select
                  style={{
                    height: 32,
                    background: "#FFFFFF",
                    borderColor: "transparent",
                  }}
                  sx={{
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  label="Отчёт"
                  id="demo-select-small-label"
                  defaultValue={"internal"}
                  onChange={(e) => {
                    console.log(e.target.value);
                    setReportView(e.target.value === "internal" ? "not_fake" : "fake");
                    setReportType(e.target.value);
                    setCurrentPage(1);
                    setUpd(!upd);
                  }}
                >
                  <MenuItem value={"default"}>Внешний отчет</MenuItem>
                  <MenuItem value={"internal"}>Внутренний отчет</MenuItem>
                  <MenuItem value={"external"}>Статистика от сеток</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <button
              style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 20px", fontSize: 14, borderRadius: 5 }}
              onClick={async () => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append(
                  "Authorization",
                  "Bearer " + localStorage.getItem("admin_token")
                );
          
                  const _startDate = typeof filtersValue.date.date_start === "number" ? new Date(filtersValue.date.date_start) : filtersValue.date.date_start
                  const _endDate = typeof filtersValue.date.date_end === "number" ? new Date(filtersValue.date.date_end) : filtersValue.date.date_end
            
                  const date_start = new Date(`${_startDate.getFullYear()}.${_startDate.getMonth()+1}.${_startDate.getDate()} 00:00:00+03:00`).getTime() / 1000
                  const date_end = addOneDay(new Date(`${_endDate.getFullYear()}.${_endDate.getMonth()+1}.${_endDate.getDate()} 00:00:00+03:00`)).getTime() / 1000
          
                  const response = await fetch(
                    `${DOMAIN_API_HOST}/api/v1/ssp-stats/export?ssppartner_id=${partnerData.id}&date_from=${date_start}&date_to=${date_end}&breakdown_type=${tableType}&report_type=${reportType}`,
                    {
                      method: "GET",
                      headers: myHeaders,
                    }
                  );
              
                  if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
              
                    link.download = `${tableType}_statistics_${partnerData.name}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
              
                    link.remove();
                    window.URL.revokeObjectURL(url);
                  } else {
                    console.error("Ошибка при скачивании файла:", response.statusText);
                  }
                }}
              >
                Скачать
            </button>
          </div>

          <button
            style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
            onClick={() => {
              setUpd((prev) => !prev);
              enqueueSnackbar("Запрос на обновление таблицы.", {
                variant: "success",
                autoHideDuration: 1000,
                anchorOrigin: { vertical: "top", horizontal: "right" },
              });
            }}
            >
              Обновить таблицу
          </button>
        </div>
        {
          !isLoading ? (
            <div>
              {
                tableType === "details" && (
                  detailGetTableData().length > 0 ? (
                    <DataTable data={detailGetTableData()} columns={detailColumns} />
                  ) : (
                    <div>Данные не найдены</div>
                  )
                )
              }

              {
                tableType === "geo" && (
                  geoGetTableData().length > 0 ? (
                    <DataTable data={geoGetTableData()} columns={getGeoColumns()} />
                  ) : (
                    <div>Данные не найдены</div>
                  )
                )
              }

              {
                tableType === "domain" && (
                  domainGetTableData().length > 0 ? (
                    <DataTable data={domainGetTableData()} columns={getDomainColumns()} />
                  ) : (
                    <div>Данные не найдены</div>
                  )
                )
              }

              {
                tableType === "finance" && (
                  financeGetTableData().length > 0 ? (
                    <DataTable data={financeGetTableData()} columns={getFinanceColumns()} />
                  ) : (
                    <div>Данные не найдены</div>
                  )
                )
              }
            </div>
          ) : (
            <div>Загрузка данных...</div>
          )
        }
      </div>

      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 20, marginTop: "auto" }}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 5, marginTop: 20 }}>
          <button
            style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
            onClick={() => handlePageChange("prev")}
            disabled={currentPage === 1}
          >
            {"Назад"}
          </button>
          <h4 style={{ letterSpacing: 1.5 }}>
            {currentPage} / {totalPages}
          </h4>
          <button
            style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "3px 15px", fontSize: 14, borderRadius: 5 }}
            onClick={() => handlePageChange("next")}
            disabled={currentPage === totalPages}
          >
            {"Дальше"}
          </button>
        </Box>
      </div>
    </div>

  );
};



const BlackList = ({ partnerData }) => {
  const [blacklist, setBlacklist] = useState([]);
  const [error, setError] = useState(null);

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append(
    "Authorization",
    "Bearer " + localStorage.getItem("admin_token")
  );


  const listsSchema = z.array(
    z
      .string()
      .min(3, "Минимум 3 символа.")
      .max(255, "Максимальная длина домена 255 символов.")
      .regex(
        /^(https?:\/\/)?(?!.*\.\.)(?=[^\s]{4,253}$)(?=.{2,}\.[^.]{2,}$)([a-zA-Zа-яё0-9-]{1,63}\.?){2,3}[^.\s]{2,}$/,
        "Некорректная ссылка на сайт."
      )
      .refine((value) => !blacklist.includes(value), "Такой сайт уже добавлен.")
  );

  const addToBlacklist = async (input) => {
    const items = input
      .split(" ")
      .map((item) => item.trim())
      .filter(Boolean);
    try {
      listsSchema.parse(items);
      setBlacklist((prev) => [...new Set([...prev, ...items])]);
      setError(null);
      await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update?_id=${partnerData.id}`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ blacklist_domains: [...new Set([...blacklist, ...items])] }),
      });
    } catch (error) {
      setError(error.errors[0].message);
    }
  };

  
  const removeFromBlacklist = async (item) => {
    setBlacklist((prev) => prev.filter((i) => i !== item));
    await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update?_id=${partnerData.id}`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ blacklist_domains: blacklist.filter((i) => i !== item) }),
    });
  };

  useEffect(() => {
    async function fetchData() {
      const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/fetch_blacklists?_type=domains&_id=${partnerData.id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (res.ok) {
        const data = await res.json();
        setBlacklist(data);
      }
    }
    fetchData();
  }, []);

  return (
    <div style={{ border: "1px solid #e0e0e0", padding: "20px", borderRadius: "10px" }}>
      <h3>Полное совпадение</h3>
      <div>
        <input
          onInput={() => setError(null)}
          style={{ marginTop: "10px", width: "200px", border: "1px solid grey" }}
          placeholder="Ссылки через пробел"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              addToBlacklist(e.target.value);
              e.target.value = "";
            }
          }}
          type="text"
        />
        {error && <p style={{ color: "red", marginTop: "5px" }}>{error}</p>}
      </div>

      <h3 style={{ marginTop: "20px" }}>Список сайтов:</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "20px", width: "100%" }}>
        {blacklist.map((item, index) => (
          <div key={index} style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: "center", background: "#e0e0e063", width: "max-content", padding: "10px 20px", borderRadius: "20px" }}>
            {item}
            <svg
              onClick={() => removeFromBlacklist(item)}
              style={{ cursor: "pointer" }}
              xmlns="http://www.w3.org/2000/svg"
              width="16" height="16"
              fill="#000000"
              viewBox="0 0 256 256"
            >
              <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};



const PartialList = ({ partnerData }) => {
  const [blacklist, setBlacklist] = useState([]);
  const [error, setError] = useState(null);

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append(
    "Authorization",
    "Bearer " + localStorage.getItem("admin_token")
  );

  const listsSchema = z.array(
    z
      .string()
      .min(3, "Минимум 3 символа.")
      .max(255, "Максимальная длина текста 255 символов.")
      .refine((value) => !blacklist.includes(value), "Такой текст уже добавлен.")
  );

  const addToBlacklist = async (input) => {
    const items = input
      .split(" ")
      .map((item) => item.trim())
      .filter(Boolean);
    try {
      listsSchema.parse(items);
      setBlacklist((prev) => [...new Set([...prev, ...items])]);
      setError(null);
      await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update?_id=${partnerData.id}`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ blacklist_partial: [...new Set([...blacklist, ...items])] }),
      });
    } catch (error) {
      setError(error.errors[0].message);
    }
  };

  const removeFromBlacklist = async (item) => {
    setBlacklist((prev) => prev.filter((i) => i !== item));
    await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update?_id=${partnerData.id}`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ blacklist_partial: blacklist.filter((i) => i !== item) }),
    });
  };

  useEffect(() => {
    async function fetchData() {
      const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/fetch_blacklists?_type=partial&_id=${partnerData.id}`, {
        method: "GET",
        headers: myHeaders,
      });
      if (res.ok) {
        const data = await res.json();
        setBlacklist(data);
      }
    }
    fetchData();
  }, []);

  return (
    <div style={{ border: "1px solid #e0e0e0", padding: "20px", borderRadius: "10px" }}>
      <h3>Частичное совпадение</h3>
      <div>
        <input
          onInput={() => setError(null)}
          style={{ marginTop: "10px", width: "200px", border: "1px solid grey" }}
          placeholder="Введите текст через пробел"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              addToBlacklist(e.target.value);
              e.target.value = "";
            }
          }}
          type="text"
        />
        {error && <p style={{ color: "red", marginTop: "5px" }}>{error}</p>}
      </div>

      <h3 style={{ marginTop: "20px" }}>Список текстов:</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "20px", width: "100%" }}>
        {blacklist.map((item, index) => (
          <div key={index} style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: "center", background: "#e0e0e063", width: "max-content", padding: "10px 20px", borderRadius: "20px" }}>
            {item}
            <svg
              onClick={() => removeFromBlacklist(item)}
              style={{ cursor: "pointer" }}
              xmlns="http://www.w3.org/2000/svg"
              width="16" height="16"
              fill="#000000"
              viewBox="0 0 256 256"
            >
              <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};





// Компонент модального окна для настройки лимитов просмотров
const ViewsLimitModal = ({ openModal, setOpenModal, platformSettings, setPlatformSettings, partnerData, onSaved }) => {
  const closeModal = () => setOpenModal(false);
  const [percentFocused, setPercentFocused] = useState({});
  const { enqueueSnackbar } = useSnackbar();

  const formatsActive = ['banner', 'video', 'native', 'inapp-banner', 'inapp-video', 'inapp-native'];
  const platformMap = { programmatic: 'Programmatic', retargeo: 'Retargeo' };
  const formatToContentType = {
    'banner': 'IMAGE',
    'video': 'VIDEO',
    'native': 'NATIVE',
    'inapp-banner': 'INAPP_IMAGE',
    'inapp-video': 'INAPP_VIDEO',
    'inapp-native': 'INAPP_NATIVE',
  };
  const contentTypeToFormat = {
    'IMAGE': 'banner',
    'VIDEO': 'video',
    'NATIVE': 'native',
    'INAPP_IMAGE': 'inapp-banner',
    'INAPP_VIDEO': 'inapp-video',
    'INAPP_NATIVE': 'inapp-native',
  };

  // Загрузка настроек при открытии модалки по партнёру
  useEffect(() => {
    const fetchSettings = async () => {
      if (!openModal || !partnerData?.name) return;
      try {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('admin_token'));
        const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/dsp-settings/fetch?filter_partner_name=${encodeURIComponent(partnerData.name)}`, {
          method: 'GET',
          headers: myHeaders,
        });
        if (!res.ok) return;
        const list = await res.json();
        // Подготовим новое состояние
        const next = JSON.parse(JSON.stringify(platformSettings));
        // обнулим проценты и enabled оставим как есть
        Object.keys(next).forEach(p => {
          DSP_FORMATS.forEach(f => {
            next[p][f].percent = null;
          });
          // не затираем platform_limit здесь, он придёт из content_type=null
        });
        const hasTotalForPlatform = { programmatic: false, retargeo: false };
        // применим с бэка
        list.forEach(item => {
          const platformKey = item.platform_name === 'Programmatic' ? 'programmatic' : 'retargeo';
          const formatKey = contentTypeToFormat[item.content_type];
          if (!platformKey) return;
          // content_type == null => общий лимит платформы
          if (item.content_type === null) {
            next[platformKey].platform_limit = Number(item.views_daily_limit) || null;
            next[platformKey].platform_views_daily_count = Number(item.views_daily_count) || 0;
            hasTotalForPlatform[platformKey] = true;
            return;
          }
          if (!formatKey) return;
          next[platformKey][formatKey].enabled = Boolean(item.enabled);
          next[platformKey][formatKey].percent = item.views_daily_percent_limit != null ? Math.round(Number(item.views_daily_percent_limit) * 100) : next[platformKey][formatKey].percent;
          next[platformKey][formatKey].views_daily_count = Number(item.views_daily_count) || 0;
        });
        // Пытаемся оценить общий лимит платформы как сумму рассчитанных по процентам лимитов, если пер-форматные лимиты присутствуют
        Object.keys(next).forEach(p => {
          if (!hasTotalForPlatform[p]) {
            const items = list.filter(i => (i.platform_name === platformMap[p] && i.content_type !== null));
            if (items.length > 0) {
              const sum = items.reduce((acc, it) => acc + (Number(it.views_daily_limit) || 0), 0);
              next[p].platform_limit = sum || next[p].platform_limit;
            }
          }
        });
        setPlatformSettings(next);
      } catch (e) {
        // ignore
      }
    };
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal, partnerData?.name]);

  const saveSettings = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('admin_token'));

      const tasks = [];
      Object.keys(platformSettings).forEach(platformKey => {
        const platformName = platformMap[platformKey];
        const total = Number(platformSettings[platformKey].platform_limit || 0);
        {
          const urlTotal = `${DOMAIN_API_HOST}/api/v1/admin/dsp-settings/update?platform_name=${encodeURIComponent(platformName)}&partner_name=${encodeURIComponent(partnerData.name)}`;
          const bodyTotal = { views_daily_limit: total };
          tasks.push(fetch(urlTotal, { method: 'POST', headers: myHeaders, body: JSON.stringify(bodyTotal) }));
        }
        DSP_FORMATS.forEach(formatKey => {
          const pct = platformSettings[platformKey][formatKey].percent;
          if (pct == null) return; // пропускаем неуказанные проценты
          const enabled = Boolean(platformSettings[platformKey][formatKey].enabled);
          const contentType = formatToContentType[formatKey];
          const limit = Math.floor((total * Number(pct)) / 100);
          const body = {
            views_daily_limit: limit,
            views_daily_percent_limit: Number(pct) / 100,
            enabled,
          };
          const url = `${DOMAIN_API_HOST}/api/v1/admin/dsp-settings/update?platform_name=${encodeURIComponent(platformName)}&partner_name=${encodeURIComponent(partnerData.name)}&content_type=${encodeURIComponent(contentType)}`;
          tasks.push(fetch(url, { method: 'POST', headers: myHeaders, body: JSON.stringify(body) }));
        });
      });
      const results = await Promise.all(tasks);
      const ok = results.every(r => r.ok);
      enqueueSnackbar(ok ? 'Настройки сохранены' : 'Часть настроек сохранить не удалось', { variant: ok ? 'success' : 'error' });
      if (ok && onSaved) onSaved();
    } catch (e) {
      enqueueSnackbar('Ошибка сохранения настроек', { variant: 'error' });
    }
  };
  
  const modalStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: openModal ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  };
  
  const modalContentStyles = {
    backgroundColor: '#fff',
    width: '90%',
    maxWidth: 850,
    maxHeight: '80vh',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    overflowY: 'auto',
  };

  const handlePlatformLimitChange = (platform, value) => {
    const numValue = value === '' ? null : parseInt(value) || null;
    setPlatformSettings(prev => ({
      ...prev,
      [platform]: {
        ...prev[platform],
        platform_limit: numValue
      }
    }));
  };

  const handleFocus = (e) => {
    if (e.target.value === '0') {
      e.target.select();
    }
  };

  return (
    <div style={modalStyles} onClick={closeModal}>
      <div style={modalContentStyles} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginBottom: '20px', fontSize: '18px' }}>
          Настройка лимитов на показы по партнёру - <span style={{ fontWeight: '600' }}>{partnerData?.display_name || partnerData?.name || 'Неизвестный партнёр'}</span>
        </h3>
        <div style={{ display: 'flex', gap: 20, marginBottom: 10 }}>
          {Object.keys(platformSettings).map(platform => {
            const totalPercent = DSP_FORMATS.reduce((sum, f) => sum + (Number(platformSettings[platform][f].percent || 0)), 0);
            const isOk = totalPercent === 100;
            const factTotal = Number(platformSettings[platform].platform_views_daily_count || 0);
            return (
              <div key={platform} style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 12px',
                border: `1px solid ${isOk ? '#d5d5d5' : '#ffadad'}`,
                background: isOk ? '#f9f9f9' : '#fff4f4',
                borderRadius: 6
              }}>
                <span style={{ fontSize: 13 }}>
                  {platform === 'programmatic' ? 'Programmatic' : 'Retargeo'} — сумма процентов: <b>{totalPercent}%</b>
                </span>
                <span style={{ fontSize: 13 }}>
                  Факт: <b>{factTotal.toLocaleString('ru-RU')}</b>
                </span>
              </div>
            );
          })}
        </div>
        
        <div style={{ display: 'flex', gap: '20px' }}>
          {Object.keys(platformSettings).map(platform => (
            <div key={platform} style={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: '8px', padding: '15px' }}>
              <h4 style={{ marginBottom: '15px', textAlign: 'center', color: '#3F73F9' }}>
                {platform === 'programmatic' ? 'Programmatic' : 'Retargeo'}
              </h4>
              
              {/* Общий лимит на платформу */}
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '600' }}>
                  Общий лимит на платформу
                </label>
              <div style={{ marginBottom: '20px' }}>

                <input
                  type="number"
                  value={platformSettings[platform].platform_limit || ''}
                  onChange={(e) => handlePlatformLimitChange(platform, e.target.value)}
                  onFocus={handleFocus}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #d5d5d5',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                  placeholder="Введите общий лимит"
                />
              </div>
              
              {/* Проценты по форматам */}
              <div style={{ marginBottom: '10px' }}>
                <h5 style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: '600', color: '#666' }}>
                  Распределение процентов по форматам (должно быть 100%):
                </h5>
              </div>
              
              {DSP_FORMATS.map(format => (
                <div key={format} style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '500' }}>
                    {format.charAt(0).toUpperCase() + format.slice(1).replace('-', ' ')}
                  </label>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    <input
                      type="text"
                      min={0}
                      max={100}
                      value={(() => {
                        const key = platform + ':' + format;
                        const pct = platformSettings[platform][format].percent;
                        const isFocused = !!percentFocused[key];
                        if (isFocused) return pct ?? '';
                        return pct === null || pct === undefined || pct === '' ? '' : String(pct) + '%';
                      })()}
                      onChange={(e) => {
                        const raw = e.target.value;
                        const digits = raw.replace(/\D/g, '');
                        const parsed = digits === '' ? null : parseInt(digits, 10);
                        const clamped = parsed === null ? null : Math.max(0, Math.min(100, parsed));
                        setPlatformSettings(prev => ({
                          ...prev,
                          [platform]: {
                            ...prev[platform],
                            [format]: {
                              ...prev[platform][format],
                              percent: clamped
                            }
                          }
                        }));
                      }}
                      onFocus={() => {
                        const key = platform + ':' + format;
                        setPercentFocused(prev => ({ ...prev, [key]: true }));
                      }}
                      onBlur={() => {
                        const key = platform + ':' + format;
                        setPercentFocused(prev => ({ ...prev, [key]: false }));
                        // Нормализуем пустое значение к null
                        const pct = platformSettings[platform][format].percent;
                        if (pct === '' || pct === undefined) {
                          setPlatformSettings(prev => ({
                            ...prev,
                            [platform]: {
                              ...prev[platform],
                              [format]: { ...prev[platform][format], percent: null }
                            }
                          }));
                        }
                      }}
                      style={{
                        width: 120,
                        padding: '8px',
                        border: '1px solid #d5d5d5',
                        borderRadius: '4px',
                        fontSize: '14px'
                      }}
                      placeholder="%"
                    />
                    <span style={{ fontSize: 12, color: '#666' }}>
                      факт: {Number(platformSettings[platform][format].views_daily_count || 0).toLocaleString('ru-RU')}
                    </span>
                    <span style={{ fontSize: 12, color: '#666' }}>
                      = {(() => {
                        const total = Number(platformSettings[platform].platform_limit || 0);
                        const pct = Number(platformSettings[platform][format].percent || 0);
                        const calc = Math.floor((total * pct) / 100);
                        return isNaN(calc) ? 0 : calc.toLocaleString('ru-RU');
                      })()} показов
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button
            onClick={closeModal}
            style={{
              padding: '8px 16px',
              backgroundColor: '#f5f5f5',
              color: '#333',
              border: '1px solid #d5d5d5',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Отмена
          </button>
          {(() => {
            const totals = Object.fromEntries(Object.keys(platformSettings).map(p => [p, formatsActive.reduce((s, f) => s + (Number(platformSettings[p][f].percent || 0)), 0)]));
            const allOk = Object.values(totals).every(v => v === 100);
            return (
              <button
                onClick={async () => { await saveSettings(); closeModal(); }}
                disabled={!allOk}
                style={{
                  padding: '8px 16px',
                  backgroundColor: allOk ? '#3F73F9' : '#9fb7ff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: allOk ? 'pointer' : 'not-allowed'
                }}
              >
                Сохранить
              </button>
            );
          })()}
        </div>
      </div>
    </div>
  );
};

// Компонент модального окна для настройки статуса активности
const ActiveStatusModal = ({ openModal, setOpenModal, platformSettings, setPlatformSettings, partnerData }) => {
  const closeModal = () => setOpenModal(false);
  const { enqueueSnackbar } = useSnackbar();
  const platformMap = { programmatic: 'Programmatic', retargeo: 'Retargeo' };
  const formatToContentType = {
    'banner': 'IMAGE',
    'video': 'VIDEO',
    'native': 'NATIVE',
    'inapp-banner': 'INAPP_IMAGE',
    'inapp-video': 'INAPP_VIDEO',
    'inapp-native': 'INAPP_NATIVE',
  };
  const contentTypeToFormat = {
    'IMAGE': 'banner',
    'VIDEO': 'video',
    'NATIVE': 'native',
    'INAPP_IMAGE': 'inapp-banner',
    'INAPP_VIDEO': 'inapp-video',
    'INAPP_NATIVE': 'inapp-native',
  };

  // Загрузка enabled/percent при открытии модалки (как в лимитах)
  useEffect(() => {
    const fetchSettings = async () => {
      if (!openModal || !partnerData?.name) return;
      try {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('admin_token'));
        const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/dsp-settings/fetch?filter_partner_name=${encodeURIComponent(partnerData.name)}`, {
          method: 'GET',
          headers: myHeaders,
        });
        if (!res.ok) return;
        const list = await res.json();
        const next = JSON.parse(JSON.stringify(platformSettings));
        // Сбросим enabled/percent для форматов, platform_enabled загрузим отдельно
        const anyEnabled = { programmatic: false, retargeo: false };
        list.forEach(item => {
          const platformKey = item.platform_name === 'Programmatic' ? 'programmatic' : 'retargeo';
          if (!platformKey) return;
          if (item.content_type === null) {
            // Загружаем статус платформы из записи с content_type=null
            next[platformKey].platform_enabled = Boolean(item.enabled);
            return;
          }
          const formatKey = contentTypeToFormat[item.content_type];
          if (!formatKey) return;
          next[platformKey][formatKey].enabled = Boolean(item.enabled);
          next[platformKey][formatKey].percent = item.views_daily_percent_limit != null ? Math.round(Number(item.views_daily_percent_limit) * 100) : next[platformKey][formatKey].percent;
          if (next[platformKey][formatKey].enabled) anyEnabled[platformKey] = true;
        });
        // Если статус платформы не пришёл с бэка, определяем по форматам
        Object.keys(next).forEach(p => {
          if (next[p].platform_enabled === undefined) {
            next[p].platform_enabled = Boolean(anyEnabled[p]);
          }
        });
        setPlatformSettings(next);
      } catch (e) {
        // ignore
      }
    };
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal, partnerData?.name]);
  
  const modalStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: openModal ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  };
  
  const modalContentStyles = {
    backgroundColor: '#fff',
    width: '90%',
    maxWidth: 800,
    maxHeight: '80vh',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    overflowY: 'auto',
  };

  const handleStatusChange = (platform, format, enabled) => {
    setPlatformSettings(prev => ({
      ...prev,
      [platform]: {
        ...prev[platform],
        [format]: {
          ...prev[platform][format],
          enabled
        }
      }
    }));
  };

  const handlePlatformStatusChange = (platform, enabled) => {
    setPlatformSettings(prev => {
      const nextPlatform = { ...prev[platform], platform_enabled: enabled };
      DSP_FORMATS.forEach(f => {
        if (nextPlatform[f]) {
          nextPlatform[f] = { ...nextPlatform[f], enabled };
        }
      });
      return { ...prev, [platform]: nextPlatform };
    });
  };

  return (
    <div style={modalStyles} onClick={closeModal}>
      <div style={modalContentStyles} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginBottom: '20px', fontSize: '18px' }}>
          Настройка статуса активности для партнёра - <span style={{ fontWeight: '600' }}>{partnerData?.display_name || partnerData?.name || 'Неизвестный партнёр'}</span>
        </h3>
        
        <div style={{ display: 'flex', gap: '20px' }}>
          {Object.keys(platformSettings).map(platform => (
            <div key={platform} style={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: '8px', padding: '15px' }}>
              <h4 style={{ marginBottom: '15px', textAlign: 'center', color: '#3F73F9' }}>
                {platform === 'programmatic' ? 'Programmatic' : 'Retargeo'}
              </h4>
              
              {/* Общий статус платформы */}
              <div style={{ 
                marginBottom: '20px', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderRadius: '6px',
              }}>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>
                  Общий статус платформы
                </span>
                <Switch
                  checked={platformSettings[platform].platform_enabled}
                  onChange={(e) => handlePlatformStatusChange(platform, e.target.checked)}
                  color="primary"
                />
              </div>
              
              {/* Статусы по форматам */}
              <div style={{ marginBottom: '10px' }}>
                <h5 style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: '600', color: '#666' }}>
                  Статусы по форматам:
                </h5>
              </div>
              
              {DSP_FORMATS.map(format => (
                <div key={format} style={{ 
                  marginBottom: '15px', 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  padding: '10px',
                  backgroundColor: platformSettings[platform].platform_enabled ? '#f9f9f9' : '#f5f5f5',
                  borderRadius: '8px',
                  opacity: platformSettings[platform].platform_enabled ? 1 : 0.6
                }}>
                  <span style={{ fontSize: '14px', fontWeight: '500' }}>
                    {format.charAt(0).toUpperCase() + format.slice(1).replace('-', ' ')}
                  </span>
                  <Switch
                    checked={platformSettings[platform][format].enabled && platformSettings[platform].platform_enabled}
                    onChange={(e) => handleStatusChange(platform, format, e.target.checked)}
                    color="primary"
                    disabled={!platformSettings[platform].platform_enabled}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button
            onClick={closeModal}
            style={{
              padding: '8px 16px',
              backgroundColor: '#f5f5f5',
              color: '#333',
              border: '1px solid #d5d5d5',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Отмена
          </button>
          <button
            onClick={async () => {
              try {
                const myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
                myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('admin_token'));
                const tasks = [];
                Object.keys(platformSettings).forEach(platformKey => {
                  const platformName = platformMap[platformKey];
                  
                  // Сохраняем статус платформы (platform_enabled)
                  const platformEnabled = Boolean(platformSettings[platformKey].platform_enabled);
                  const platformUrl = `${DOMAIN_API_HOST}/api/v1/admin/dsp-settings/update?platform_name=${encodeURIComponent(platformName)}&partner_name=${encodeURIComponent(partnerData.name)}`;
                  const platformBody = { enabled: platformEnabled };
                  tasks.push(fetch(platformUrl, { method: 'POST', headers: myHeaders, body: JSON.stringify(platformBody) }));
                  
                  // Сохраняем статусы форматов
                  DSP_FORMATS.forEach(formatKey => {
                    const enabled = Boolean(platformSettings[platformKey][formatKey].enabled);
                    const contentType = formatToContentType[formatKey];
                    const body = {
                      enabled,
                    };
                    const url = `${DOMAIN_API_HOST}/api/v1/admin/dsp-settings/update?platform_name=${encodeURIComponent(platformName)}&partner_name=${encodeURIComponent(partnerData.name)}&content_type=${encodeURIComponent(contentType)}`;
                    tasks.push(fetch(url, { method: 'POST', headers: myHeaders, body: JSON.stringify(body) }));
                  });
                });
                const res = await Promise.all(tasks);
                const ok = res.every(r => r.ok);
                enqueueSnackbar(ok ? 'Статусы сохранены' : 'Часть статусов сохранить не удалось', { variant: ok ? 'success' : 'error' });
              } catch (e) {
                enqueueSnackbar('Ошибка сохранения статусов', { variant: 'error' });
              }
              closeModal();
            }}
            style={{
              padding: '8px 16px',
              backgroundColor: '#3F73F9',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
};

const OpenModal = ({ openModal, setOpenModal, type, partnerData }) => {
  let modalContent;

  const ModalStats = ({ openModal, setOpenModal, children }) => {
    const closeModal = () => setOpenModal(false);
  
    const modalStyles = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: openModal ? 'flex' : 'none',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999,
    };
  
    const modalContentStyles = {
      backgroundColor: '#fff',
      width: '80%',
      maxWidth: 400,
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    };
  
    return (
      <div style={modalStyles} onClick={closeModal}>
        <div style={modalContentStyles} onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    );
  };

  switch (type) {
    case "banners_stats":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={defaultStyles}>
            <h3 style={{ fontSize: 18 }}>
              Статистика баннеров по партнёру - {partnerData.name}
            </h3>
            {Object.keys(partnerData).length !== 0 && <BannersStatsData partnerData={partnerData}/>}
          </Box>
          
        </ModalStats>
      );
      break;

    case "blacklist":
      modalContent = (
        <ModalStats
          openModal={openModal}
          setOpenModal={() => setOpenModal(false)}
        >
          <Box sx={defaultStyles}>
            <h3 style={{ fontSize: 18, marginBottom: 20 }}>
              Черный список по партнёру - {partnerData.name}
            </h3>
            {Object.keys(partnerData).length !== 0 && (
              <div style={{ display: "flex", flexDirection: "column", width: "900px", gap: 20 }}>
                <BlackList partnerData={partnerData}/>
                <PartialList partnerData={partnerData}/>
              </div>
            )}
          </Box>
          
        </ModalStats>
      );
      break;


    default:
      modalContent = null;
  }

  return modalContent;
};


function Dsp() {
  const [filterArr, setFilter] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const debounceTimers = useRef({});
  const updateQueues = useRef({});
  const isUpdating = useRef({});
  const [partnerData, setPartnerData] = useState({});
  
  // Состояние для настроек лимитов и статусов
  const [platformSettings, setPlatformSettings] = useState({
    programmatic: {
      platform_limit: null, // Общий лимит на платформу
      platform_enabled: true, // Общий статус платформы
      banner: { views_daily_limit: null, enabled: true, percent: null },
      video: { views_daily_limit: null, enabled: true, percent: null },
      native: { views_daily_limit: null, enabled: true, percent: null },
      'inapp-banner': { views_daily_limit: null, enabled: true, percent: null },
      'inapp-video': { views_daily_limit: null, enabled: true, percent: null },
      'inapp-native': { views_daily_limit: null, enabled: true, percent: null }
    },
    retargeo: {
      platform_limit: null, // Общий лимит на платформу
      platform_enabled: true, // Общий статус платформы
      banner: { views_daily_limit: null, enabled: true, percent: null },
      video: { views_daily_limit: null, enabled: true, percent: null },
      native: { views_daily_limit: null, enabled: true, percent: null },
      'inapp-banner': { views_daily_limit: null, enabled: true, percent: null },
      'inapp-video': { views_daily_limit: null, enabled: true, percent: null },
      'inapp-native': { views_daily_limit: null, enabled: true, percent: null }
    }
  });

  // Состояние для модальных окон
  const [viewsLimitModalOpen, setViewsLimitModalOpen] = useState(false);
  const [activeStatusModalOpen, setActiveStatusModalOpen] = useState(false);
  const [modalPartnerData, setModalPartnerData] = useState({});
  const [limitsByPartner, setLimitsByPartner] = useState({});

  const fetchPartnerLimits = async (partnerName) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('admin_token'));
      const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/dsp-settings/fetch?filter_partner_name=${encodeURIComponent(partnerName)}`, {
        method: 'GET',
        headers: myHeaders,
      });
      if (!res.ok) return null;
      const data = await res.json();
      return computePartnerLimitUtilization(data);
    } catch {
      return null;
    }
  };

  const fetchAllPartnerLimits = async (partners) => {
    const results = await Promise.all(
      partners.map(async (partner) => {
        const utilization = await fetchPartnerLimits(partner.name);
        return { name: partner.name, utilization };
      })
    );
    const map = {};
    results.forEach(({ name, utilization }) => {
      if (utilization) map[name] = utilization;
    });
    setLimitsByPartner(map);
  };

  useEffect(() => {
    async function fetchData() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/fetch`, {
        method: "GET",
        headers: myHeaders,
      });
      if (res.ok) {
        const data = await res.json();
        setFilter(data);
        fetchAllPartnerLimits(data);
      }
    }
    fetchData();
  }, []);

  const FormatNumberInput = ({ el, handleChange, fieldName }) => {
    const [formattedValue, setFormattedValue] = useState('');

    useEffect(() => {
      const value = el[fieldName] === null ? 0 : el[fieldName];
      setFormattedValue(value.toLocaleString('ru-RU'));
    }, [el, fieldName]);

    const handleInputChange = (e) => {
      const rawValue = e.target.value.replace(/\D/g, '');
      const numberValue = Number(rawValue);
      
      const formatted = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

      setFormattedValue(formatted);
      handleChange(fieldName, numberValue, el.id);
    };

    return (
      <div className="td">
        <input
          onChange={handleInputChange}
          defaultValue={el[fieldName] === null ? 0 : el[fieldName]}
          value={formattedValue}
          type="text"
          style={{
            height: 25,
            border: "1px solid #d5d5d5", 
            width: "100%",
            padding: "10px"
          }}
        />
      </div>
    );
  };


  const debounceUpdate = (field, partner_id, callback, delay = 500) => {
    const uniqueKey = `${field}-${partner_id}`;
    clearTimeout(debounceTimers.current[uniqueKey]);

    debounceTimers.current[uniqueKey] = setTimeout(() => {
        if (!updateQueues.current[uniqueKey]) updateQueues.current[uniqueKey] = [];
        updateQueues.current[uniqueKey].push(callback);
        processUpdateQueue(uniqueKey);
    }, delay);
  };

  const processUpdateQueue = async (uniqueKey) => {
      if (isUpdating.current[uniqueKey] || !updateQueues.current[uniqueKey] || updateQueues.current[uniqueKey].length === 0) return;

      isUpdating.current[uniqueKey] = true;

      while (updateQueues.current[uniqueKey].length > 0) {
          const callback = updateQueues.current[uniqueKey].shift();
          await callback();
      }

      isUpdating.current[uniqueKey] = false;
  };

  const handleChange = (field, value, partner_id) => {
      debounceUpdate(field, partner_id, async () => {
          console.log(field, value, partner_id);
          await updateFields({ [field]: value }, partner_id);
      });
  };

  const updateFields = async (fields, partner_id) => {
      if (partner_id === null) return;
      console.debug(fields, partner_id);
      await fetch(`${DOMAIN_API_HOST}/api/v1/admin/ssp-partner-net/update?_id=${partner_id}`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem("admin_token")}`,
          },
          body: JSON.stringify(fields),
      });
  };

  const columns = [
    {
      Header: "SSP",
      accessor: "name",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Наименование партнёрской сети",
      accessor: "display_name",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
      isSticky: true,
    },
    {
      Header: "CPM",
      accessor: "cpm",
      maxWidth: 400,
      minWidth: 80,
      width: 100,
    },
    {
      Header: "Запущено РК",
      accessor: "campaigns_count",
      maxWidth: 400,
      minWidth: 80,
      width: 120,
    },
    {
      Header: "Дневной лимит на показы",
      accessor: "views_daily_limit",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: (
        <div>
          <div>Освоение лимитов</div>
          <div style={{ fontSize: '11px', color: '#999', marginTop: '2px', fontWeight: 400 }}>
            Programmatic / Retargeo
          </div>
        </div>
      ),
      accessor: "limits_utilization",
      maxWidth: 400,
      minWidth: 80,
      width: 160,
    },
    {
      Header: "Статистика по проектам",
      accessor: "banners_stats",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Черный список сайтов",
      accessor: "blacklist",
      maxWidth: 400,
      minWidth: 80,
      width: 135,
    },
    {
      Header: "Статус активности",
      accessor: "active_status",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    }
  ];


  function getTableData() {
    return filterArr.sort((a, b) => a.name.localeCompare(b.name)).map((el) => {
      return {
        display_name: <div className="td">{el.display_name}</div>,
        name: <div className="td">{el.name}</div>,
        cpm: (
          <FormatNumberInput
            el={el}
            fieldName="cpm"
            handleChange={handleChange}
          />
        ),
        campaigns_count: <div className="td">{el.enabled_campaigns}</div>,
        spend: (
          <div className="td" style={{ display: "flex", gap: 10, alignItems: "center" }}>
            {el.consumption.toLocaleString('ru-RU') + " ₽"}
          </div>
        ),
        views_daily_limit: (
          <button
            onClick={() => {
              setModalPartnerData(el);
              setViewsLimitModalOpen(true);
            }}
            style={{
              padding: "5px 10px", 
              fontSize: "12px", 
              fontWeight: "500", 
              borderRadius: 5, 
              background: "#DFE8FF", 
              color: "#3F73F9",
              border: "none",
              cursor: "pointer"
            }}
          >
            Настроить
          </button>
        ),
        limits_utilization: (() => {
          const util = limitsByPartner[el.name] || {};
          const renderPercent = (val) => {
            if (val === null || val === undefined) {
              return <span style={{ color: '#999' }}>—</span>;
            }
            return (
              <span style={{ color: getLimitUtilizationColor(val), fontWeight: 600 }}>
                {val}%
              </span>
            );
          };
          return (
            <div className="td" style={{ display: 'flex', gap: 4, alignItems: 'center', justifyContent: 'center' }}>
              {renderPercent(util.programmatic)}
              <span style={{ color: '#999' }}>/</span>
              {renderPercent(util.retargeo)}
            </div>
          );
        })(),
        views_daily_count: <div className="td">{el.views_daily_count}</div>,
        start_cycle_date: (
          <div className="td" style={{ height: 40 }}>
            <DatePickerTest
              defaultValue={el.start_of_period}
              onChange={(date) => {
                const formattedDate = new Date(date).toISOString().split('T')[0];
                handleChange('start_of_period', formattedDate, el.id);
              }}
            />
          </div>
        ),
        end_cycle_date: (
          <div className="td" style={{ height: 40 }}>
            <DatePickerTest
              defaultValue={el.end_of_period}
              onChange={(date) => {
                const formattedDate = new Date(date).toISOString().split('T')[0];
                handleChange('end_of_period', formattedDate, el.id);
              }}
            />
          </div>
        ),
        banners_stats: (
          <button
            onClick={() => {
              setPartnerData(el)
              setOpenModal(true)
              setModalType("banners_stats")
            }}
            style={{padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9"}}>
            Открыть 
          </button>
        ),
        blacklist: (
          <button
            onClick={() => {
              setPartnerData(el)
              setOpenModal(true)
              setModalType("blacklist")
            }}
            style={{padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9"}}>
            Открыть 
          </button>
        ),
        active_status: (
          <button
            onClick={() => {
              setModalPartnerData(el);
              setActiveStatusModalOpen(true);
            }}
            style={{
              padding: "5px 10px", 
              fontSize: "12px", 
              fontWeight: "500", 
              borderRadius: 5, 
              background: "#DFE8FF", 
              color: "#3F73F9",
              border: "none",
              cursor: "pointer"
            }}
          >
            Настроить
          </button>
        ),
      };
    });
  }
  return (
    <div className="logs" style={{ width: "100%", height: "97%" }}>
      <div className="filters">
        <div className="searchDate">
          <DateFromTo withoutStartDate={true} handleChange={() => {}} />
        </div>
      </div>
      <div style={{ overflowX: "auto", width: "100%", height: "94%", overflowY: "auto" }}>
        <DataTable data={getTableData()} columns={columns} />
      </div>
      <OpenModal openModal={openModal} setOpenModal={setOpenModal} type={modalType} partnerData={partnerData}/>
      
      {/* Модальные окна для настройки лимитов и статусов */}
      <ViewsLimitModal 
        openModal={viewsLimitModalOpen} 
        setOpenModal={setViewsLimitModalOpen}
        platformSettings={platformSettings}
        setPlatformSettings={setPlatformSettings}
        partnerData={modalPartnerData}
        onSaved={async () => {
          if (!modalPartnerData?.name) return;
          const utilization = await fetchPartnerLimits(modalPartnerData.name);
          if (utilization) {
            setLimitsByPartner((prev) => ({ ...prev, [modalPartnerData.name]: utilization }));
          }
        }}
      />
      
      <ActiveStatusModal 
        openModal={activeStatusModalOpen} 
        setOpenModal={setActiveStatusModalOpen}
        platformSettings={platformSettings}
        setPlatformSettings={setPlatformSettings}
        partnerData={modalPartnerData}
      />
    </div>
  );
}

export default Dsp;
